import {Directive, ElementRef, HostListener} from "@angular/core";

@Directive({
  selector: "img[ptMissingImg]",
})
export class MissingImgDirective {
  constructor(private el: ElementRef) {
  }

  @HostListener("error")
  private onError() {
    // this.el.nativeElement.style.display = "none";
    this.el.nativeElement.setAttribute("src", "assets/images/missing-image.png");
  }
}
